var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "flex-grow": "1" } }, [
    _c("iframe", {
      ref: "myIframe",
      style: { border: "none", marginLeft: "10px" },
      attrs: {
        "same-site": "none",
        src: _vm.jumpUrl,
        width: "99%",
        height: "99%"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }